/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DesilFilteredResponse,
  DesilListResponse,
  FailureResponse,
  GetPublicDesilFilteredParams,
  GetPublicDesilParams,
  PublicDesilLatestResponse,
  PublicDesilStatistikResponse,
  SuccessEnvelope,
  ValidationFailureResponse
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicDesilUrl = (params?: GetPublicDesilParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/public/desil?${stringifiedParams}` : `/public/desil`
}

export const getPublicDesil = async (params?: GetPublicDesilParams, options?: RequestInit): Promise<SuccessEnvelope & DesilListResponse> => {

  return publicFetch<SuccessEnvelope & DesilListResponse>(getGetPublicDesilUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicDesilQueryKey = (params?: GetPublicDesilParams,) => {
    return [
    `/public/desil`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicDesilQueryOptions = <TData = Awaited<ReturnType<typeof getPublicDesil>>, TError = ValidationFailureResponse | FailureResponse>(params?: GetPublicDesilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicDesilQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicDesil>>> = ({ signal }) => getPublicDesil(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicDesilQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicDesil>>>
export type GetPublicDesilQueryError = ValidationFailureResponse | FailureResponse


export function useGetPublicDesil<TData = Awaited<ReturnType<typeof getPublicDesil>>, TError = ValidationFailureResponse | FailureResponse>(
 params: undefined |  GetPublicDesilParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesil>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesil<TData = Awaited<ReturnType<typeof getPublicDesil>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesil>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesil>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesil<TData = Awaited<ReturnType<typeof getPublicDesil>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicDesil<TData = Awaited<ReturnType<typeof getPublicDesil>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesil>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicDesilQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicDesilFilteredUrl = (params?: GetPublicDesilFilteredParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/public/desil/filtered?${stringifiedParams}` : `/public/desil/filtered`
}

export const getPublicDesilFiltered = async (params?: GetPublicDesilFilteredParams, options?: RequestInit): Promise<SuccessEnvelope & DesilFilteredResponse> => {

  return publicFetch<SuccessEnvelope & DesilFilteredResponse>(getGetPublicDesilFilteredUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicDesilFilteredQueryKey = (params?: GetPublicDesilFilteredParams,) => {
    return [
    `/public/desil/filtered`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicDesilFilteredQueryOptions = <TData = Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError = ValidationFailureResponse | FailureResponse>(params?: GetPublicDesilFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicDesilFilteredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicDesilFiltered>>> = ({ signal }) => getPublicDesilFiltered(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicDesilFilteredQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicDesilFiltered>>>
export type GetPublicDesilFilteredQueryError = ValidationFailureResponse | FailureResponse


export function useGetPublicDesilFiltered<TData = Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError = ValidationFailureResponse | FailureResponse>(
 params: undefined |  GetPublicDesilFilteredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilFiltered>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilFiltered>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilFiltered<TData = Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilFiltered>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilFiltered>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilFiltered<TData = Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicDesilFiltered<TData = Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError = ValidationFailureResponse | FailureResponse>(
 params?: GetPublicDesilFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilFiltered>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicDesilFilteredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicDesilLatestUrl = () => {




  return `/public/desil/latest`
}

export const getPublicDesilLatest = async ( options?: RequestInit): Promise<SuccessEnvelope & PublicDesilLatestResponse> => {

  return publicFetch<SuccessEnvelope & PublicDesilLatestResponse>(getGetPublicDesilLatestUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicDesilLatestQueryKey = () => {
    return [
    `/public/desil/latest`
    ] as const;
    }


export const getGetPublicDesilLatestQueryOptions = <TData = Awaited<ReturnType<typeof getPublicDesilLatest>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicDesilLatestQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicDesilLatest>>> = ({ signal }) => getPublicDesilLatest({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicDesilLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicDesilLatest>>>
export type GetPublicDesilLatestQueryError = FailureResponse


export function useGetPublicDesilLatest<TData = Awaited<ReturnType<typeof getPublicDesilLatest>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilLatest>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilLatest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilLatest<TData = Awaited<ReturnType<typeof getPublicDesilLatest>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilLatest>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilLatest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilLatest<TData = Awaited<ReturnType<typeof getPublicDesilLatest>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicDesilLatest<TData = Awaited<ReturnType<typeof getPublicDesilLatest>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilLatest>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicDesilLatestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicDesilStatistikUrl = () => {




  return `/public/desil/statistik`
}

export const getPublicDesilStatistik = async ( options?: RequestInit): Promise<SuccessEnvelope & PublicDesilStatistikResponse> => {

  return publicFetch<SuccessEnvelope & PublicDesilStatistikResponse>(getGetPublicDesilStatistikUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicDesilStatistikQueryKey = () => {
    return [
    `/public/desil/statistik`
    ] as const;
    }


export const getGetPublicDesilStatistikQueryOptions = <TData = Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicDesilStatistikQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicDesilStatistik>>> = ({ signal }) => getPublicDesilStatistik({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicDesilStatistikQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicDesilStatistik>>>
export type GetPublicDesilStatistikQueryError = FailureResponse


export function useGetPublicDesilStatistik<TData = Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilStatistik>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilStatistik>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilStatistik<TData = Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicDesilStatistik>>,
          TError,
          Awaited<ReturnType<typeof getPublicDesilStatistik>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicDesilStatistik<TData = Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicDesilStatistik<TData = Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicDesilStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicDesilStatistikQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






